import React from 'react';

import { FaAppleAlt, FaChartLine, FaDumbbell, FaHeartbeat, FaTint, FaUtensils } from 'react-icons/fa';

import { StyledAboutFeaturesSection } from './styles';
import { TitleBadge } from '../../../components/atoms/title-badge';
import { Heading11, Heading7, Paragraph3 } from '../../../theme';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('about-features-section');

const features = [
  {
    icon: <FaUtensils />,
    title: 'Recipe Library',
    description: 'Access thousands of delicious recipes tailored to your dietary preferences and nutritional goals.',
  },
  {
    icon: <FaDumbbell />,
    title: 'Workout Routines',
    description: 'From HIIT to yoga, discover workouts designed for every fitness level and schedule.',
  },
  {
    icon: <FaTint />,
    title: 'Hydration Tracking',
    description: 'Stay on top of your water intake with smart reminders and personalized daily goals.',
  },
  {
    icon: <FaAppleAlt />,
    title: 'Nutrition Plans',
    description: 'Get AI-powered meal plans that adapt to your preferences, allergies, and health objectives.',
  },
  {
    icon: <FaChartLine />,
    title: 'Progress Analytics',
    description: 'Visualize your journey with detailed charts, insights, and weekly progress reports.',
  },
  {
    icon: <FaHeartbeat />,
    title: 'Wellness Insights',
    description: 'Receive personalized health recommendations based on your activity and nutrition data.',
  },
];

const AboutFeaturesSection = () => {
  return (
    <StyledAboutFeaturesSection>
      <div className={b()}>
        <div className={b('inner')}>
          <div className={b('heading')}>
            <TitleBadge text="FEATURES" />
            <Heading7>Everything You Need to Succeed</Heading7>
            <Paragraph3>
              Our comprehensive suite of tools empowers you to take control of your health journey.
            </Paragraph3>
          </div>
          <div className={b('grid')}>
            {features.map((feature, index) => (
              <div key={index} className={b('card')}>
                <div className={b('card-icon')}>{feature.icon}</div>
                <Heading11>{feature.title}</Heading11>
                <Paragraph3>{feature.description}</Paragraph3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </StyledAboutFeaturesSection>
  );
};

export default AboutFeaturesSection;
